import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import { useUrlSearch } from '@/search';

import getAxiosConfig from '../helpers/getAxiosConfig';
import getVideosComposeTransform from '../helpers/getVideoComposeTransform';
import handleVideoUnauthorizedError from '../helpers/handleVideoUnauthorizedError';

export default ({ isEnabled = true } = {}) => {
  const { orgId, id, type } = useParams();
  const isInLiveMode = type === 'live';
  const urlSearch = useUrlSearch();
  const versionId = urlSearch.getValue('version_id');
  const [shouldForceRender, setShouldForceRender] = useState(false);

  const videoComposeKey = useMemo(
    () => ['videoCompose', type, id, versionId],
    [id, type, versionId],
  );

  const videoCompose = useQuery(
    videoComposeKey,
    async () => {
      try {
        const { data } = await axios(
          getAxiosConfig('get-video-compose', { id, isInLiveMode, versionId }),
        );
        return getVideosComposeTransform({ data });
      } catch (error) {
        handleVideoUnauthorizedError({
          error,
          orgId,
          type,
          conditionedQueryCache: videoCompose,
        });
        return {};
      }
    },
    { enabled: isEnabled, placeholderData: {} },
  );

  useEffect(() => {
    if (!isEnabled) return;

    setShouldForceRender(true); // force render due to medium editor
    setTimeout(() => setShouldForceRender(false), 0);
  }, [isEnabled, versionId]);

  return { shouldForceRender, videoCompose, videoComposeKey };
};
